import type { ThemeColorName } from '@examdojo/styles';
import type { JsxgraphThemeService } from '../../jsxgraph-theme.service';
import type { LabelStyleResult, LabelVariant } from './label.model';

/**
 * Get label colors based on variant and color.
 */
export function getLabelStyle(
  themeService: JsxgraphThemeService,
  variant: LabelVariant,
  color: ThemeColorName,
): LabelStyleResult {
  const theme = themeService.getTheme();

  switch (variant) {
    case 'primary':
      return {
        backgroundColor: themeService.getColor(color),
        textColor: theme.labelColors.white,
      };
    case 'secondary':
      return {
        backgroundColor: theme.labelColors.bgLight(color),
        textColor: theme.labelColors.textDark(color),
      };
    case 'tertiary':
      return {
        backgroundColor: 'transparent',
        textColor: theme.labelColors.textDarker(color),
      };
  }
}
